module.exports = __webpack_public_path__ + "c2d2b6a45e31cc481fc26ca3eb415a14.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/large/certificate-of-authenticity.jpg
 ** module id = 401
 ** module chunks = 0
 **/